var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUsePlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24193 19978)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 151,
    rx: 75.5,
    transform: "translate(-24193 -19978)",
    fill: "#f6f5f7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24160 -19945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.02,56.528H46.934L76.8,26.683V12.62Z",
    transform: "translate(-34.02 -12.62)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.483,44.713V15.777h-9.878V34.568L432.22,12.62V26.683l29.862,29.846H475Z",
    transform: "translate(-389.444 -12.62)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 48.218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.02,461.48h3.142v12.089h6.066V461.48h3.1v29.153h-3.1V476.407H37.162v14.227H34.02Z",
    transform: "translate(-34.02 -461.48)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.823,532.476v11.061c0,3.842-1.61,5.78-4.861,5.78-3.414,0-4.657-2.167-4.657-5.747V532.476c0-3.71,1.709-5.676,4.8-5.676C190.344,526.8,191.823,529.034,191.823,532.476Zm-7.132-.1v11.363c0,2.5.886,3.448,2.364,3.448,1.544,0,2.365-.953,2.365-3.547V532.379c0-2.329-.789-3.448-2.4-3.448-1.572,0-2.327,1.055-2.327,3.452Z",
    transform: "translate(-166.37 -519.783)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.74,529.56V546.6c0,1.806.624,3.057,2.3,3.057s2.233-1.183,2.233-3.022V529.56h2.364v16.978c0,3.382-1.544,5.254-4.657,5.254-3.022,0-4.564-1.707-4.564-5.189V529.56Z",
    transform: "translate(-267.328 -522.246)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.2,542.867v1.281c0,2.068.728,3.152,2.266,3.152,1.576,0,2.167-1.118,2.167-3.547,0-2.562-.559-3.547-2.857-5.353-2.365-1.84-3.547-2.956-3.547-6.174,0-2.79.854-5.452,4.269-5.419,3.283,0,4.138,2.167,4.138,4.959v1.019h-2.329v-.953c0-1.806-.329-2.988-1.84-2.988s-1.905,1.31-1.905,3.022c0,2.038.426,2.824,2.431,4.334,3.056,2.3,4.007,3.612,4.007,7.225,0,3.087-.886,5.912-4.6,5.912-3.513,0-4.532-2.329-4.532-5.222v-1.249Z",
    transform: "translate(-361.461 -519.789)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.808,540.889h-4.927v8.472h5.583l-.291,2.135H507.55V529.56h7.52v2.169h-5.189v6.995h4.927Z",
    transform: "translate(-456.682 -522.246)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.188,461.48v22.65c0,2.4.829,4.058,3.056,4.058s2.968-1.572,2.968-4.016V461.48h3.142v22.56c0,4.5-2.051,6.986-6.2,6.986-4.015,0-6.066-2.271-6.066-6.9V461.48Z",
    transform: "translate(-546.42 -461.48)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.99,533.12h3.944c3.18,0,4.69,1.6,4.69,5.075v1.31c0,3.212-.964,5.589-4.85,5.589H752.3v9.475h-2.313V533.12Zm2.313,10.054h1.253c2.441,0,2.794-1.477,2.794-3.694v-1.15c0-1.735-.386-3.276-2.6-3.276H752.3v8.127Z",
    transform: "translate(-673.078 -525.423)",
    fill: "#d2d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.271 75.633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M811.37,717.732a1.09,1.09,0,1,1-1.087-1.061,1.067,1.067,0,0,1,1.087,1.061Zm-1.91,0a.823.823,0,0,0,.828.847.848.848,0,0,0,0-1.7.825.825,0,0,0-.828.849Zm.654.556h-.246v-1.061a2.181,2.181,0,0,1,.408-.032.66.66,0,0,1,.368.077.291.291,0,0,1,.1.233.272.272,0,0,1-.22.246v.013a.313.313,0,0,1,.195.259.767.767,0,0,0,.079.265h-.265a.925.925,0,0,1-.084-.259c-.019-.117-.083-.169-.22-.169h-.117v.428Zm0-.6h.117c.137,0,.246-.045.246-.156s-.071-.163-.227-.163a.6.6,0,0,0-.137.013v.306Z",
    transform: "translate(-809.19 -716.671)",
    fill: "#d2d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.33 80.124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.09,759.58h2.122c1.227,0,1.7.367,1.7,1.134a.949.949,0,0,1-.9,1v.017a1.087,1.087,0,0,1,1.064,1.1c0,.672-.492,1.252-1.712,1.252H37.09Zm.648,1.892h1.655c.541,0,.873-.205.873-.684,0-.418-.205-.7-1.089-.7H37.739Zm0,2.091h1.55c.873,0,1.108-.342,1.108-.777,0-.517-.355-.8-1.145-.8H37.738Z",
    transform: "translate(-37.09 -759.464)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.769,759.58h.64v2.684a2.1,2.1,0,0,1-4.183,0V759.58h.648v2.714a1.445,1.445,0,0,0,2.889,0Z",
    transform: "translate(-88.094 -759.464)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.535,764.067v-1.875l-2.135-2.62h.834l1.624,2.08,1.626-2.086h.834l-2.135,2.62v1.875Z",
    transform: "translate(-137.336 -759.456)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.987,770.01a1.126,1.126,0,1,1-1.127,1.127,1.127,1.127,0,0,1,1.127-1.127Z",
    transform: "translate(-218.078 -768.773)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.116,759.783c-.063-.629-.7-.8-1.432-.8-.642,0-1.183.317-1.183.815,0,.243.146.492.7.582l1.675.291c.728.125,1.064.542,1.064,1.1,0,.9-.8,1.438-2.135,1.438-1.276,0-2.016-.474-2.1-1.463h.685c.019.6.6.953,1.455.953.933,0,1.455-.367,1.455-.859,0-1.244-3.444-.118-3.444-2,0-.866.728-1.364,1.961-1.364.933,0,1.924.279,1.987,1.31Z",
    transform: "translate(-279.531 -758.472)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.521,759.58h3.361v.509h-2.714v1.419h2.541v.511h-2.541v1.544h2.789v.511H367.52V759.58Z",
    transform: "translate(-332.024 -759.464)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.44,759.58h.648v3.984h2.589v.511H420.44Z",
    transform: "translate(-379.259 -759.464)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.37,759.58h.648v3.984h2.591v.511H468.37Z",
    transform: "translate(-422.04 -759.464)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.116,770.01a1.126,1.126,0,1,1-1.126,1.127A1.127,1.127,0,0,1,545.116,770.01Z",
    transform: "translate(-489.537 -768.773)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.168,764.074h-.648V759.58h2.209c1.389,0,1.7.467,1.7,1.189a1.072,1.072,0,0,1-1.028,1.046v.012c.6.076.766.319.883,1.077a5.414,5.414,0,0,0,.255,1.164h-.685c-.118-.319-.188-.946-.306-1.455-.076-.323-.291-.555-1.134-.555h-1.252v2Zm0-2.515h1.474c.684,0,1.1-.162,1.1-.728,0-.547-.3-.728-1.089-.728h-1.487Z",
    transform: "translate(-552.49 -759.464)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.651,759.58h3.361v.509H672.3v1.419h2.541v.511H672.3v1.544h2.789v.511H671.65V759.58Z",
    transform: "translate(-603.484 -759.464)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.942,759.58h.646v4.494H726.7l-2.751-3.835h-.013v3.835h-.648V759.58h.883l2.751,3.835h.013V759.58Z",
    transform: "translate(-649.574 -759.464)",
    fill: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.9,760.127H778.99v-.547h4.457v.547h-1.905v3.947H780.9Z",
    transform: "translate(-699.292 -759.464)",
    fill: "#d2d1d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsePlaceholder);
export default __webpack_public_path__ + "static/media/ic_use_placeholder.3ba3ee9840c629d3df9a097401a2d06e.svg";
export { ForwardRef as ReactComponent };